import keyBy from 'lodash/keyBy';

import { GlobalAction, LeadItem, LeadState } from '.';

const GET_LEADS_START = 'GET_LEADS_START';
const GET_LEADS_ERROR = 'GET_LEADS_ERROR';
const GET_LEADS_SUCCESS = 'GET_LEADS_SUCCESS';
const ADD_LEAD_START = 'ADD_LEAD_START';
const ADD_LEAD_ERROR = 'ADD_LEAD_ERROR';
const ADD_LEAD_SUCCESS = 'ADD_LEAD_SUCCESS';

export const leadReducer = (
  state: LeadState,
  action: GlobalAction
): LeadState => {
  const { payload, type } = action;
  switch (type) {
    case GET_LEADS_START:
    case ADD_LEAD_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_LEADS_ERROR:
    case ADD_LEAD_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }
    case GET_LEADS_SUCCESS: {
      return {
        ...state,
        leads: keyBy(payload.leads, 'leadId'),
        count: payload.count,
        loading: false,
        order: payload.leads.map((lead: LeadItem) => lead.leadId),
      };
    }
    case ADD_LEAD_SUCCESS: {
      return {
        ...state,
        leads: {
          ...state.leads,
          [payload.lead.leadId]: payload.lead,
        },
        count: state.count + 1,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export const LEADS_ACTIONS = {
  GET_LEADS_START,
  GET_LEADS_ERROR,
  GET_LEADS_SUCCESS,
  ADD_LEAD_START,
  ADD_LEAD_ERROR,
  ADD_LEAD_SUCCESS,
};
